import { render, staticRenderFns } from "./NewsDetails.vue?vue&type=template&id=c4d6aaf8&scoped=true&"
import script from "./NewsDetails.vue?vue&type=script&lang=js&"
export * from "./NewsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d6aaf8",
  null
  
)

export default component.exports